import Icon from '../components/Icon.vue'

Icon.register({
  'briefcase-medical': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V128H48C21.5 128 0 149.5 0 176V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V176C512 149.5 490.5 128 464 128zM192 96H320V128H192V96zM352 344C352 348.4 348.4 352 344 352H288V408C288 412.4 284.4 416 280 416H232C227.6 416 224 412.4 224 408V352H168C163.6 352 160 348.4 160 344V296C160 291.6 163.6 288 168 288H224V232C224 227.6 227.6 224 232 224H280C284.4 224 288 227.6 288 232V288H344C348.4 288 352 291.6 352 296V344z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/briefcase-medical.js
// module id = QsD9
// module chunks = 144